type IColors = "danger" | "success" | "warning" | "dark" | "tertiary" | "light" | "medium" | "info"

var loader = null as any

export const ShowToast = async (message:string,header?:string,color?:IColors,callback?:any) => {
        const toast = document.createElement('ion-toast')
        toast.header = header
        toast.message = message
        toast.color = color
        toast.position = 'top'
        toast.duration = 5000
        toast.mode = "md"
        toast.buttons = [{
              text: 'Ok',
              role: 'cancel',
              handler: callback
            }
          ];
      
        document.body.appendChild(toast);
        return toast.present();
    }

export const  ShowLoader = async (message?:string,duration?:number|null) => {
        loader = document.createElement('ion-loading');
        loader.message = message?message:"Espere...";
        if(duration!==null){
            loader.duration = duration||3000
        }
      
        document.body.appendChild(loader);
        await loader.present();
    }

export const  UpdateLoader = async (message?:string) => {
        if(loader){
            loader.message = message?message:"Espere...";
            await loader.present();
        }
    }

export const HideLoader = async () => {
        if(loader){
            await loader.dismiss()
        }
    }